<template>
    <!-- Contact -->
  <section id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Contactame</h2>
          <h3 class="section-subheading text-muted">Si tenés alguna consulta, escribime.</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <form id="form" name="sentMessage" novalidate="novalidate">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input class="form-control" id="name" type="text" 
                        v-bind:show="name"
                        v-model="name"
                        v-bind:rules="nameRules"
                        placeholder="Tu nombre *" required="required" 
                        data-validation-required-message="Por favor, ingresa tu nombre.">
                  <p class="help-block text-danger"></p>
                </div>
                <div class="form-group">
                  <input class="form-control" id="email" type="email" 
                         v-bind:show="email"
                         v-model="email"
                          :rules="emailRules"
                          placeholder="Tu Email *" required="required" 
                         data-validation-required-message="Por favor, ingresa tu email.">
                  <p class="help-block text-danger"></p>
                </div>
                <div class="form-group">
                  <input class="form-control" id="phone" type="tel" 
                         v-bind:show="phone"
                         placeholder="Tu teléfono"> 
                  <p class="help-block text-danger"></p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <textarea class="form-control" id="message" 
                            v-bind:show="message"
                            v-model="message"
                            :rules="messageRules"
                            placeholder="Tu mensaje *" required="required" 
                            data-validation-required-message="Por favor, ingresa tu mensaje."></textarea>
                  <p class="help-block text-danger"></p>
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="col-lg-12 text-center">
                <div id="success"></div>
                <button id="sendMessageButton" 
                      :disabled="!valid"   
                      @submit.prevent="enviar"
                      class="btn btn-primary btn-xl text-uppercase" 
                      type="submit">Enviar mensaje</button>
                      
              <button id="clear" 
                      @click="clear" class="btn btn-primary btn-xl text-uppercase" 
                      >Limpiar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div> 
  </section>
</template>
<script>
import emailjs from 'emailjs-com';

export default {
    name:'contact-component',
    data: () => ({
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "Completar el nombre es obligatorio",
      v => (v && v.length > 3) || "El nombre debe ser mayor a tres caracteres"
    ],
    phone:"",
    email: "",
    emailRules: [
      v => !!v || "Complete el E-mail por favor",
      v => /.+@.+/.test(v) || "E-mail es un campo obligatorio"
    ],
    message: "",
    messageRules: [v => !!v || "Complete el E-mail por favor"]
  }),
  methods: {
    created(){
        emailjs.init("user_RI997MSpuSzbYMBPYkI2k")
    },
    enviar(e){
            let data = {
                from_name: this.from_name,
                from_email: this.from_email,
                message: this.message,
                subject: this.subject,
            };
            
            emailjs.send("service_f1yzfqg","template_zh4b9h9", data)
            .then(function(response) {
                if(response.text === 'OK'){
                    alert('El correo se ha enviado de forma exitosa');
                }
                console.log("SUCCESS. status=%d, text=%s", response.status, response.text);
            }, function(err) {
                alert('Ocurrió un problema al enviar el correo');
                console.log("FAILED. error=", err);
            });
        },
    clear() {
        this.$refs.form.reset();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ContactComponent/contactComponent.vue